import { __extends } from 'tslib';
import { jsxs, jsx } from 'react/jsx-runtime';
import { playCheckboxSound } from '@wg/web2clientapi/sound';
import classNames from 'classnames';
import * as React from 'react';
import styles from './Checkbox.module.scss.js';

var Checkbox = (function (_super) {
    __extends(Checkbox, _super);
    function Checkbox() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onChange = function (event) {
            playCheckboxSound();
            if (_this.props.onChange) {
                _this.props.onChange(!_this.props.isChecked);
            }
        };
        return _this;
    }
    Checkbox.prototype.onClick = function (event) {
        event.stopPropagation();
    };
    Checkbox.prototype.render = function () {
        return (jsxs("label", { className: classNames(styles.label, this.props.className), onClick: this.onClick, children: [jsx("input", { className: styles.input, type: "checkbox", checked: this.props.isChecked, disabled: this.props.isDisabled, onChange: this.onChange }), jsx("span", { className: styles.checkbox })] }));
    };
    Checkbox.defaultProps = {
        isChecked: false,
        isDisabled: false,
    };
    return Checkbox;
}(React.PureComponent));

export { Checkbox as default };
//# sourceMappingURL=Checkbox.js.map
